import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Calendar, BookOpen, BarChart3, CalendarDays, CalendarRange } from 'lucide-react';

export default function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { icon: Home, label: 'Início', path: '/dashboard', testId: 'nav-dashboard' },
    { icon: Calendar, label: 'Hoje', path: '/schedule', testId: 'nav-schedule' },
    { icon: CalendarDays, label: 'Agenda', path: '/calendar', testId: 'nav-calendar' },
    { icon: CalendarRange, label: 'Anual', path: '/planner', testId: 'nav-planner' },
    { icon: BookOpen, label: 'Temas', path: '/topics', testId: 'nav-topics' },
    { icon: BarChart3, label: 'Stats', path: '/analytics', testId: 'nav-analytics' },
  ];

  return (
    <>
      {/* Mobile: Bottom Bar */}
      <nav 
        className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 shadow-lg"
        data-testid="mobile-nav"
        style={{ background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(12px)' }}
      >
        <div className="grid grid-cols-6 gap-1 px-2 py-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPath === item.path || currentPath.startsWith(item.path + '/');
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center gap-1 py-2 px-1 rounded-lg transition-all ${
                  isActive 
                    ? 'text-blue-600 bg-blue-50 dark:bg-blue-900/30' 
                    : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800'
                }`}
                data-testid={item.testId}
              >
                <Icon className="w-5 h-5" />
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>

      {/* Desktop: Sidebar Vertical */}
      <nav 
        className="hidden lg:flex fixed top-0 left-0 bottom-0 z-50 w-20 flex-col bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-700 shadow-lg"
        data-testid="desktop-sidebar"
        style={{ background: 'rgba(255, 255, 255, 0.98)', backdropFilter: 'blur(12px)' }}
      >
        {/* Logo/Brand */}
        <div className="flex items-center justify-center h-20 border-b border-slate-200 dark:border-slate-700">
          <div className="w-11 h-11 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-md">
            <span className="text-white font-bold text-xl">A</span>
          </div>
        </div>

        {/* Nav Items - Distribuídos uniformemente */}
        <div className="flex-1 flex flex-col items-center justify-evenly py-6 px-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPath === item.path || currentPath.startsWith(item.path + '/');
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`group relative flex flex-col items-center justify-center gap-1.5 w-14 h-14 rounded-xl transition-all duration-200 ${
                  isActive 
                    ? 'text-blue-600 bg-blue-50 dark:bg-blue-900/30 shadow-sm' 
                    : 'text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-slate-100 dark:hover:bg-slate-800'
                }`}
                data-testid={`${item.testId}-desktop`}
              >
                <Icon className={`w-5 h-5 transition-transform duration-200 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`} />
                <span className="text-[9px] font-medium leading-none">{item.label}</span>
                
                {/* Active indicator */}
                {isActive && (
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-blue-600 rounded-r-full" />
                )}
              </button>
            );
          })}
        </div>

        {/* Bottom spacer */}
        <div className="h-6" />
      </nav>
    </>
  );
}
